import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Button,
  Table,
  Badge,Form,Modal
} from "@themesberg/react-bootstrap";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getVendordetail } from "../../app/api";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import moment from "moment";
import { useCreateNotesMutation,useFetchVendorNotesQuery  } from "../../store/app/apislice";
import swal from "sweetalert";
import ButtonLoader from "../../components/ButtonLoader";

export default () => {
  const { id } = useParams();
  const history = useHistory();
    const [createNotes, { isLoading: isCreatingNotes }] = useCreateNotesMutation();
    const { data: notes, isLoading, isError, error } = useFetchVendorNotesQuery(id);
    // console.log(notes)
// "created_at": "2025-02-13 07:20:29",
const[createdAt,setCreatedAt]=useState("")
  const [vendorName, setVendorName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [position, setPosition] = useState("");
  const [status, setStatus] = useState("");
  const [registStatus, setRegistStatus] = useState("");
  const [assets, setAssets] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [timeoff, setTimeOff] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [worklocation, setWorkLocation] = useState("");
  const [loading, setLoading] = useState(false);
    const [show2, setShow2] = useState(false);
     const [notesDescription, setNotesDescription] = useState("");
      const [titleNotes, setTitleNotes] = useState("");
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
  const fetchSingleVendor = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getVendordetail(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setVendorName(response.data?.data?.vendor_details?.contact_person);
      setPhoneNumber(response.data?.data?.vendor_details?.phone);
      setCompany(response.data?.data?.vendor_details?.company_name);
      setEmail(response.data?.data?.vendor_details?.email);
      setAddress(response.data?.data?.vendor_details?.address);
      setPosition(response.data?.data?.vendor_details?.position);
      setWorkLocation(response.data?.data?.vendor_details?.location);
      setStatus(response.data?.data?.vendor_details?.status);
      setRegistStatus(response.data?.data?.vendor_details?.register_status);
      setAssets(response.data?.data?.vendor_assets);
      setReminders(response.data?.data?.reminders);
      setTimeOff(response.data?.data?.time_off);
      setContracts(response.data?.data?.vendorContracts);
      setCreatedAt(response.data?.data?.vendor_details?.created_at);

    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
   const handleSubmitNotes = async () => {
  
      const notesData = {
        title: titleNotes,
        description: notesDescription,
        vendor_id:id
      };
  
      try {
        const response = await createNotes(notesData).unwrap();
        
        console.log(response)
          swal({
            text: response.message,
            icon: "success",
          });
         
          handleClose2(); // Close the modal
       
      } catch (error) {
        swal({
          text: error.data.messages.error,
          icon: "error",
        });
        console.log("Error creating notes:", error);
      }finally {
        handleClose2();
        setTitleNotes(""); // Reset title
        setNotesDescription(""); // Reset description
      }
    };
  useEffect(() => {
    fetchSingleVendor();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Vendors.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block mb-md-0">
              <h4 className="mb-0">Vendors Details</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

          {/* <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Row xs={12} sm={12} xl={12} lg={12}>
                    <Col
                      xs={4}
                      sm={4}
                      xl={4}
                      lg={4}
                      className="d-flex flex-column align-items-center justify-content-center"
                    >
                      <Card.Title>{vendorName}</Card.Title>
                    </Col>
                    <Col xs={8} sm={8} xl={8} lg={8}>
                      <Row>
                        <div className="vendor-Cont">
                          <Col xs={12} sm={6} xl={4} lg={4}>
                            <p className="vendor-title">Company Name</p>
                          </Col>
                          <Col xs={7} sm={7} xl={9} lg={9}>
                            {" "}
                            <p className="vendor-title">{vendorName}</p>{" "}
                          </Col>
                        </div>
                      </Row>
                      <Row>
                        <div className="vendor-Cont">
                          <Col xs={12} sm={6} xl={4} lg={4}>
                            <p className="vendor-title">Email</p>
                          </Col>
                          <Col xs={7} sm={7} xl={9} lg={9}>
                            {" "}
                            <p className="vendor-title">{email}</p>{" "}
                          </Col>
                        </div>
                      </Row>
                      <Row>
                        <div className="vendor-Cont">
                          <Col xs={12} sm={6} xl={4} lg={4}>
                            <p className="vendor-title">Phone Number</p>
                          </Col>
                          <Col xs={7} sm={7} xl={9} lg={9}>
                            {" "}
                            <p className="vendor-title">{phoneNumber}</p>{" "}
                          </Col>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row> */}
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Name:</p>{" "}
                        <p className="vendor-detail">{vendorName}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Contact Person:</p>
                        <p className="vendor-detail">{company}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Email:</p>
                        <p className="vendor-detail">{email}</p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Address:</p>
                        <p className="vendor-detail">{address}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">City:</p>
                        <p className="vendor-detail">Newyork</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">work location:</p>
                        <p className="vendor-detail">{worklocation}</p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Positon:</p>{" "}
                        <p className="vendor-detail">{position}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Staus:</p>{" "}
                        <p className="vendor-detail"><Badge
                                                          pill
                                                          bg="primary"
                                                          style={{
                                                            padding: "0.4rem 0.7rem",
                                                            fontSize: "0.85rem",
                                                            border: "1px solid #ddd",
                                                          }}
                                                        >{status}</Badge></p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Registeration Status:</p>{" "}
                        <p className="vendor-detail"><Badge
                                                          pill
                                                          bg="primary"
                                                          style={{
                                                            padding: "0.4rem 0.7rem",
                                                            fontSize: "0.85rem",
                                                            border: "1px solid #ddd",
                                                          }}
                                                        >{registStatus}</Badge></p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Created Date:</p>{" "}
                        <p className="vendor-detail">{moment(createdAt).format("MM/DD/YYYY HH:mm")}</p>{" "}
                      </Col>
                    </Row>
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Card.Title>Assets</Card.Title>
                  </Col>
                  <Table hover className="user-table align-items-center">
                    <thead>
                      <tr>
                        <th className="border-bottom">Title</th>

                        <th className="border-bottom">Type</th>
                        <th className="border-bottom">Serial #</th>
                        <th className="border-bottom">MAC Address</th>
                        <th className="border-bottom">VIN #</th>
                        <th className="border-bottom">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assets.length > 0 ? (
                        assets.map((asset, index) => (
                          <tr key={index}>
                            <td className="fw-normal">{asset.title}</td>
                            <td>
                              <span className="fw-normal">{asset.type}</span>
                            </td>
                            <td>
                              <span className="fw-normal">
                                {asset.serial_no}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">
                                {asset.mac_address}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">{asset.vin}</span>
                            </td>
                            <td>
                              <span className="fw-normal">
                                <Badge
                                  pill
                                  bg={
                                    asset.status === "exposed" ||
                                    asset.status === "sold"
                                      ? "light"
                                      : asset.status === "assigned"
                                      ? "danger"
                                      : "primary"
                                  }
                                  style={{
                                    padding: "0.4rem 1rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {asset.status}
                                </Badge>
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Card.Title>Time Off</Card.Title>
                  </Col>
                  <Table hover className="user-table align-items-center">
                    <thead>
                      <tr>
                        <th className="border-bottom">Vendor Name</th>

                        <th className="border-bottom">Time Off From</th>
                        <th className="border-bottom">Time Off To</th>

                        <th className="border-bottom">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timeoff.length > 0 ? (
                        timeoff.map((time, index) => (
                          <tr key={index}>
                            <td className="fw-normal">{time.vendor_name}</td>
                            <td>
                              <span className="fw-normal">
                              
                                {moment(time.time_off_from).format("MM/DD/YYYY HH:mm")}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">
                              
                                {moment(time.time_off_to).format("MM/DD/YYYY HH:mm")}
                              </span>
                            </td>

                            <td>
                              <span className="fw-normal">
                                <Badge
                                  pill
                                  bg="primary"
                                  style={{
                                    padding: "0.4rem 1rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {time.status}
                                </Badge>
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        
                    <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                  <div className="d-flex justify-content-between">
                  <Card.Title>Notes</Card.Title>
                    <Button
                        variant="primary"
                        onClick={handleShow2}
                        className=" mb-2"
                      >
                        <span>Add Notes</span>
                      </Button>
                  </div>
                   
                  </Col>
                  <Table hover className="user-table align-items-center">
                    <thead>
                      
                      <tr>
                        <th className="border-bottom">Title</th>

                        <th className="border-bottom">Description</th>
                        <th className="border-bottom">Time</th>

                      </tr>
                    </thead>
                    <tbody>
                    {notes?.data?.length > 0 ? (
                        notes?.data?.map((note, index) => (
                          <tr key={index}>
                          <td>{note?.title}</td>
                          <td>{note?.description}</td>
                          <td>{moment(note?.created_at).format("MM/DD/YYYY")}</td>
                          </tr>
                        ))
                        ):( <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr> 
                        )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Card.Title>Reminders</Card.Title>
                  </Col>
                  <Table hover className="user-table align-items-center">
                    <thead>
                      <tr>
                        <th className="border-bottom">Title</th>

                        <th className="border-bottom">Email Reminders</th>
                        <th className="border-bottom">Frequency</th>

                        <th className="border-bottom">Due Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reminders.length > 0 ? (
                        reminders.map((reminder, index) => (
                          <tr key={index}>
                            <td className="fw-normal">{reminder.title}</td>
                            <td>
                              <span className="fw-normal">
                                {reminder.email_reminder}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">
                                {reminder.frequency}
                              </span>
                            </td>

                            <td>
                              <span className="fw-normal">
                                <Badge
                                  pill
                                  bg="primary"
                                  style={{
                                    padding: "0.4rem 1rem",
                                    fontSize: "0.85rem",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                   {moment(reminder.due_date).format("MM/DD/YYYY HH:mm")}
                                 
                                </Badge>
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                  <div className="d-flex justify-content-between">
                    <Card.Title>Contracts</Card.Title>
                  <Button
                   as={Link}
                            to={Routes.ContractsAdd.path}
                        variant="primary"
                        // onClick={handleShow2}
                        className=" mb-2"
                      >
                        <span>Add Contracts</span>
                      </Button></div>
                  </Col>
                  <Table hover className="user-table align-items-center">
                    <thead>
                      <tr>
                        <th className="border-bottom">Title</th>

                        <th className="border-bottom">Expire Date</th>
                        <th className="border-bottom">Sign Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contracts.length > 0 ? (
                        contracts.map((contract, index) => (
                          <tr key={index}>
                            <td className="fw-normal">{contract.title}</td>
                            <td>
                              <span className="fw-normal">
                               
                                {moment(contract.expiration_date).format("MM/DD/YYYY HH:mm")}
                              </span>
                            </td>
                            <td>
                              <span className="fw-normal">
                                {contract.vendorsigndate ===
                                "0000-00-00 00:00:00"
                                  ? "Not Signed"
                                  : `${moment(contract.vendorsigndate).format("MM/DD/YYYY HH:mm")}`}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
      <Modal
                            style={{ top: "15%" }}
                            show={show2}
                            onHide={handleClose2}
                            scrollable
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Contract Notes</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <Form.Group id="title" className="mb-2">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                  
                                  type="text"
                                  placeholder="Enter Title"
                                  value={titleNotes} // Bind to state
                                  onChange={(e) => setTitleNotes(e.target.value)}
                                />
                              </Form.Group>
                              <Form.Group id="Note">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                className="custom-textarea" 
                                  required
                                  as="textarea"
                                  placeholder="Enter Description      "
                                  value={notesDescription} // Bind to state
                                  onChange={(e) => setNotesDescription(e.target.value)}
                                />
                              </Form.Group>
                              
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="primary" onClick={handleClose2}>
                                Close
                              </Button>
                              {isCreatingNotes ? (
                                <div className="d-flex justify-content-start">
                                  <ButtonLoader />
                                </div>
                              ) : (
                                <Button variant="primary" onClick={handleSubmitNotes} >
                                  Save changes
                                </Button>
                              )}
                            </Modal.Footer>
                          </Modal>
    </>
  );
};
